// extracted by mini-css-extract-plugin
module.exports = {"container":"changePassword_container__20I8X"};